import styled, { css } from 'styled-components';

export const ContainerStyled = styled.div<{
  isHighlighted: boolean;
  depthLevel: number;
}>`
  min-width: 80px;
  border-radius: 8px;

  ${({ depthLevel }) => {
    return css`
      margin-left: ${depthLevel * 16}px;
    `;
  }};

  ${({ isHighlighted }) => {
    return (
      isHighlighted &&
      css`
        background: var(
          --ds-background-accent-blue-subtlest,
          var(--ds-fb-background-accent-blue-subtlest)
        );
      `
    );
  }};
`;

export const ToggleExpandButtonStyled = styled.div`
  margin: -4px 0;
  width: 32px;
`;
